"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrCreatePortalRoot = exports.PORTAL_ROOT_ID = void 0;
var PORTAL_ROOT_ID = 'uikit-root';
exports.PORTAL_ROOT_ID = PORTAL_ROOT_ID;
var getOrCreatePortalRoot = function getOrCreatePortalRoot() {
  var dropdownRoot = document.getElementById(PORTAL_ROOT_ID);
  var newRoot = document.createElement('div');
  newRoot.setAttribute('id', PORTAL_ROOT_ID);
  return dropdownRoot ? dropdownRoot : document.body.appendChild(newRoot);
};
exports.getOrCreatePortalRoot = getOrCreatePortalRoot;